import { ReactElement } from 'react';
import { Route } from 'react-router';
import { DashboardContainer } from '../../../../modules/common/dashboard/DashboardContainer';
import { SwitchWithNotFound } from '../../../containers/SwitchWithNotFound';
import { DatasetDetailsHeaderContainer } from '../../../modules/datasets/containers/DatasetDetailsHeader.container';
import { DatasetDetailsContextFactory } from '../../../modules/datasets/DatasetDetails.context';
import { Home } from '../../../routes/config/Home';
import { DatasetDetailsRoute } from '../../../routes/datasets/datasetDetails.route';
import { NotFoundView } from '../../errors/NotFound.view';
import { PreviewView } from '../Preview.view';

export const DatasetDetailsView = (): ReactElement => {
  return (
    <DatasetDetailsContextFactory>
      <SwitchWithNotFound notFound={<NotFoundView />}>
        <Route path={Home.Datasets.Details.Preview.Path}>
          <PreviewView />
        </Route>
        <Route path={Home.Datasets.Details.Path}>
          <DashboardContainer>
            <DatasetDetailsHeaderContainer />
            <DatasetDetailsRoute />
          </DashboardContainer>
        </Route>
      </SwitchWithNotFound>
    </DatasetDetailsContextFactory>
  );
};
